export default __webpack_public_path__ + "static/media/texto.a3c385df.webp";